__turbopack_context__.v({
  "hoverImage": "styles-module__4VbiFG__hoverImage",
  "translucentHoverOverlay": "styles-module__4VbiFG__translucentHoverOverlay",
  "videoIcon": "styles-module__4VbiFG__videoIcon",
});
